import { useEffect } from 'react';
import { paths } from 'src/routes/paths';

/** Legacy — split into redpacket-config / packets / ledger-entries. */
export default function SocialTradingRedpacketLedgerList() {
  useEffect(() => {
    window.location.replace(paths.socialTrading.redpacketConfig.root);
  }, []);
  return null;
}
